export default "__VITE_ASSET__1w28XtCp__"